export default "__VITE_ASSET__DAm11bAm__"